module.exports = __webpack_public_path__ + "static/img/Rectangle 174.a76ce40b.png";